<template>
    <v-container>
        <v-flex class="fee-range">
            <h4>{{SpeakerApplicants.SELECT_FEE_RANGE}}</h4>
            <v-flex>
                <v-range-slider class="fee-range__slider" :max="MAX_RANGE" :min="MIN_RANGE" thumb-label="always" thumb-size="45" always-dirty ticks="always" tick-size="0" :value=[1,8] v-model="filterRange" @change="onFilterChange">
                    <template slot="thumb-label" slot-scope="props">
                        <span>
                            {{ feeValue(props.value) }}
                        </span>
                    </template>
                    <template v-slot:prepend>
                        <v-text-field
                            v-model="filterRange[0]"
                            class="mt-0 pt-0"
                            hide-details
                            solo
                            flat
                            single-line
                            :disabled="true"
                            type="number"
                            style="display: none; width :60px"></v-text-field>
                    </template>
                    <template v-slot:append>
                        <v-text-field
                            v-model="filterRange[1]"
                            class="mt-0 pt-0"
                            hide-details
                            single-line
                            :disabled="true"
                            type="number"
                            solo
                            flat
                            style="display: none; width: 60px"></v-text-field>
                    </template>
                </v-range-slider>
            </v-flex>
        </v-flex>
    </v-container>
</template>

<script>
    import { SpeakerApplicants } from "../Speakers/speakerConstant";
    import { feeRange } from "./ResourceConstants";

    export default {
        name: "SearchSpeakers_FeeRange",
        data: () => ({
            SpeakerApplicants,
            feeRange,
            MIN_RANGE: 0,
            MAX_RANGE: 8,
            speakerFeeRangeFilter: ['0', '8'],
        }),
        props: {
            applySpeakerFilter: {
                type: Function,
                required: true,
            },
        },
        created() {
            this.checkSpeakerFeeRangeFilters();
        },
        computed: {
            filterRange: {
                get() {
                    return this.speakerFeeRangeFilter;
                },
                set(value) {
                    const minValue = value[0];
                    const maxValue = value[1];
                    if (minValue <= maxValue) {
                        this.speakerFeeRangeFilter = value;
                    }
                },
            },
        },
        methods: {
            feeValue(val) {
                return this.SpeakerApplicants.FEE_RANGE_VALUES[val];
            },
            checkSpeakerFeeRangeFilters() {
                const filters = [];
                if (this.$route.query.feeRange && this.$route.query.feeRange.length) {
                    if (this.validateSpeakerFeeRangeFilters()) {
                        const value = this.$route.query.feeRange.split('~');
                        this.setSpeakerFeeRangeFilter(value);
                        filters.push({
                            label: 'MinFee',
                            filterKey: 'MinFee',
                            filterValue: `${value[0]}`,
                        });
                        filters.push({
                            label: 'MaxFee',
                            filterKey: 'MaxFee',
                            filterValue: `${value[1] === '100000+' ? '100001' : value[1]}`,
                        });
                        this.applySpeakerFilter(filters);
                    }
                }
            },
            validateSpeakerFeeRangeFilters() {
                const value = this.$route.query.feeRange.split('~');
                if (value.length === 2 && Number(value[0]) <= Number(value[1] === '100000+' ? '100001' : value[1]) && this.SpeakerApplicants.FEE_RANGE_VALUES.includes(value[0]) && this.SpeakerApplicants.FEE_RANGE_VALUES.includes(value[1])) {
                    return true;
                }

                this.$router.push({
                    query: {
                        ...this.$route.query,
                        feeRange: [this.SpeakerApplicants.FEE_RANGE_VALUES[0], this.SpeakerApplicants.FEE_RANGE_VALUES[this.SpeakerApplicants.FEE_RANGE_VALUES.length - 1]].join('~'),
                    },
                });
            },
            setSpeakerFeeRangeFilter(value) {
                this.speakerFeeRangeFilter = [this.SpeakerApplicants.FEE_RANGE_TO_KEY_CONVERTER[value[0]], this.SpeakerApplicants.FEE_RANGE_TO_KEY_CONVERTER[value[1]]];
            },
            onFilterChange() {
                if (this.filterRange[0] <= this.filterRange[1]) {
                    const range = [this.SpeakerApplicants.FEE_RANGE_VALUES[this.filterRange[0]], this.SpeakerApplicants.FEE_RANGE_VALUES[this.filterRange[1]]];
                    this.$router.push({
                        query: {
                            ...this.$route.query,
                            feeRange: range.join('~'),
                        },
                    });
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_responsive.scss";
</style>
